import { useEffect, useState } from "react";
import { Button, ButtonGroup, Col, Form, Row, Spinner } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  useAddProgramMutation,
  useGetAllProgramsQuery,
  useUpdateProgramMutation,
} from "../slices/programsApiSlice";
import {
  useGetAllGenreQuery,
  useGetAllParentalRatingQuery,
  useGetSubGenreByGenreQuery,
} from "../slices/adminApiSlice";

import { useUpdateTemplateProgramsMutation } from "../slices/templatesApiSlice.js";
import { useGetAllIdentsQuery } from "../slices/identsApiSlice.js";
import { useGetAllGraphicsValueLabelQuery } from "../slices/graphicsApiSlice.js";

const Programs = () => {
  const [selectedProgramId, setSelectedProgramId] = useState();
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [genreId, setGenreId] = useState();
  const [newProgramId, setNewProgramId] = useState();

  const [skipSubgenre, setSkipSubgenre] = useState(true);
  const [isSpinner, setIsSpinner] = useState(false);

  const [formData, setFormData] = useState({
    programName: "",
    programSynopsis: "",
    programSlotRuntime: 0,
    programSlotRuntimeHours: 0,
    programSlotRuntimeMinutes: 0,
    programParentalRating: "",
    programGenre: "",
    programSubGenre: "",
    programPreRollFileIdent: "",
    programPreRollLiveIdent: "",
    programPreRollLiveIntroIdent: "",
    programPreRollFileIdentGraphics: [],
    programPreRollLiveIdentGraphics: [],
    programPreRollLiveMediaGraphics: [],
    programPreRollFileAddBreak: 1,
    programPreRollLiveAddBreak: 1,
    programPreRollFileMediaRuntime: 0,
    programPreRollLiveMediaRuntime: 0,
    programMediaType: { mediaType: "", mediaFields: [] },
    programInProgramBreaks: 0,
  });

  const addBreakChoices = [
    { addBreak: "End of Program", addId: 1 },
    { addBreak: "Every 20 Minutes", addId: 20 },
    { addBreak: "Every 30 Minutes", addId: 30 },
    { addBreak: "Every Hour", addId: 60 },
  ];

  const {
    data: programs,
    isLoading: programsLoading,
    isError: programsError,
  } = useGetAllProgramsQuery();

  const {
    data: parentalRating,
    isLoading: parentalRatingLoading,
    isError: parentalRatingError,
  } = useGetAllParentalRatingQuery();

  const {
    data: genre,
    isLoading: genreLoading,
    isError: genreError,
  } = useGetAllGenreQuery();

  const {
    data: subgenreData,
    isLoading: subgenreDataLoading,
    isError: subgenreDataError,
  } = useGetSubGenreByGenreQuery(genreId, {
    skip: skipSubgenre,
  });

  const {
    data: idents,
    isLoading: identsLoading,
    isError: identsError,
  } = useGetAllIdentsQuery();

  const { data: graphics } = useGetAllGraphicsValueLabelQuery();

  const [updateProgram] = useUpdateProgramMutation();
  const [createProgram] = useAddProgramMutation();
  const [updateTemplatePrograms] = useUpdateTemplateProgramsMutation();

  // useEffect(() => {
  //   console.log("formData:", formData);
  // }, [formData]);

  useEffect(() => {
    if (programs) {
      if (!(typeof selectedProgramId === "string")) {
        if (typeof newProgramId === "string") {
          setSelectedProgramId(newProgramId);
          setNewProgramId();
        } else {
          setSelectedProgramId(programs[0]._id);
        }
      }
    }
    // eslint-disable-next-line
  }, [programs]);

  useEffect(() => {
    if (typeof selectedProgramId === "string") {
      const program = programs.find((obj) => obj._id === selectedProgramId);
      setFormDataDetails(setFormData, formData, program);
      setGenreId(program.Genre);
      setIsFormDirty(false);
    }
    // eslint-disable-next-line
  }, [selectedProgramId]);

  useEffect(() => {
    if (typeof genreId === "string") {
      setSkipSubgenre(false);
    }
  }, [genreId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const requiredFields = [
      "programName",
      "programSynopsis",
      "programSlotRuntime",
      "programParentalRating",
      "programGenre",
      "programSubGenre",
      "programPreRollFileAddBreak",
      "programPreRollLiveAddBreak",
    ];
    if (requiredFields.some((field) => !formData[field])) {
      toast.error("All fields are required. Document not saved.", {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "colored",
      });
      return;
    }
    try {
      var programData = {
        name: formData.programName,
        synopsis: formData.programSynopsis,
        slotRuntime: parseInt(formData.programSlotRuntime, 10),
        parentalrating: formData.programParentalRating,
        Genre: formData.programGenre,
        Subgenre: formData.programSubGenre,
        preRoll: {
          file: {
            ident: formData.programPreRollFileIdent,
            graphics: formData.programPreRollFileIdentGraphics,
            addBreak: formData.programPreRollFileAddBreak,
          },
          live: {
            ident: formData.programPreRollLiveIdent,
            introIdent: formData.programPreRollLiveIntroIdent,
            graphics: formData.programPreRollLiveIdentGraphics,
            media: formData.programPreRollLiveMediaGraphics,
            addBreak: formData.programPreRollLiveAddBreak,
          },
        },
        inProgramBreaks: parseInt(formData.programInProgramBreaks, 10),
      };
      if (
        formData.programPreRollFileMediaRuntime !== undefined &&
        formData.programPreRollFileMediaRuntime !== 0
      ) {
        programData = {
          ...programData,
          preRoll: {
            ...programData.preRoll,
            file: {
              ...programData.preRoll.file,
              mediaRuntime: parseInt(
                formData.programPreRollFileMediaRuntime,
                10
              ),
            },
          },
        };
      }
      if (
        formData.programPreRollFileMediaRuntime !== undefined &&
        formData.programPreRollLiveMediaRuntime !== 0
      ) {
        programData = {
          ...programData,
          preRoll: {
            ...programData.preRoll,
            live: {
              ...programData.preRoll.live,
              mediaRuntime: parseInt(
                formData.programPreRollLiveMediaRuntime,
                10
              ),
            },
          },
        };
      }
      if (typeof selectedProgramId === "string") {
        programData = {
          ...programData,
          id: selectedProgramId,
        };
        try {
          const updatedData = await updateProgram(programData);
          toast.info(`${updatedData?.data?.name} - Program Updated`);
        } catch (error) {
          toast.error("Failed to update program");
        }
      } else {
        try {
          const insertedData = await createProgram(programData);
          const { _id: id } = insertedData.data;
          setNewProgramId(id);
        } catch (error) {
          console.error("Error:", error);
        }
      }
      handleUpdateTemplateClick();
      setIsFormDirty(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleFormChange = (e) => {
    const { id, value } = e.target;
    if (id === "programSlotRuntimeHours") {
      setFormData((prevData) => ({
        ...prevData,
        [id]: Number(value),
        programSlotRuntime: Number(value) * 60 + formData.programSlotRuntimeMinutes,
      }));
    } else if (id === "programSlotRuntimeMinutes") {
      setFormData((prevData) => ({
        ...prevData,
        [id]: Number(value),
        programSlotRuntime:
          formData.programSlotRuntimeHours * 60 + Number(value),
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [id]: value,
      }));
    }
    id === "programGenre" && setGenreId(value);
    setIsFormDirty(true);
  };

  const handleGraphicsChange = (e, fieldName) => {
    const { name } = fieldName;
    setFormData((prevData) => ({
      ...prevData,
      [name]: e,
    }));
    setIsFormDirty(true);
  };

  const handleUpdateTemplateClick = async (e) => {
    // e.preventDefault();
    setIsSpinner(true);
    updateTemplatePrograms();
    setIsSpinner(false);
    toast.info(`Template Updated`);
  };

  const clearForm = () => {
    setSelectedProgramId();
    setFormData({
      programName: "",
      programSynopsis: "",
      programSlotRuntime: 0,
      programSlotRuntimeHours: 0,
      programSlotRuntimeMinutes: 0,
      programParentalRating: "",
      programGenre: "",
      programSubGenre: "",
      programPreRollFileIdent: "",
      programPreRollLiveIdent: "",
      programPreRollLiveIntroIdent: "",
      programPreRollFileIdentGraphics: [],
      programPreRollLiveIdentGraphics: [],
      programPreRollLiveMediaGraphics: [],
      programPreRollFileAddBreak: 1,
      programPreRollLiveAddBreak: 1,
      programPreRollFileMediaRuntime: 0,
      programPreRollLiveMediaRuntime: 0,
      programMediaType: { mediaType: "", mediaFields: [] },
      programInProgramBreaks: 0,
    });
    // setGenreId();
    setIsFormDirty(true);
  };

  return (
    <small>
      <Row className="mt-4 ">
        {programsLoading && "Loading programs..."}
        {programsError && "Error loading programs"}
        {programs && (
          <>
            <Col
              xs="3"
              style={{ height: "1000px", overflowY: "scroll" }}
              className="p-2 border border-1 "
            >
              <ButtonGroup
                vertical
                size="sm"
                className="col-12  "
              >
                {programs.map((program, i) => (
                  <Button
                    key={program._id}
                    variant={
                      selectedProgramId === program._id ? "primary" : "light"
                    }
                    onClick={() => setSelectedProgramId(program._id)}
                  >
                    <div className="text-capitalize text-start">
                      {program.name}
                    </div>
                  </Button>
                ))}
              </ButtonGroup>
            </Col>
            <Col className="p-2 border border-1 border-start-0 ">
              <Form onSubmit={handleSubmit}>
                <Row className="m-2 m-auto ">
                  <Col>
                    <Row className="h4 border-bottom py-2 ">
                      <Col className="text-center">
                        {typeof selectedProgramId === "string"
                          ? "Update Program"
                          : "Add Program"}
                      </Col>
                    </Row>
                    <Row className="pt-3 ">
                      <Col
                        sm={2}
                        className="align-self-center text-end"
                      >
                        Name:
                      </Col>
                      <Col>
                        <Form.Group controlId="programName">
                          <Form.Control
                            type="text"
                            placeholder="Enter program name"
                            value={formData.programName}
                            onChange={handleFormChange}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mt-3 ">
                      <Col
                        sm={2}
                        className="text-end "
                      >
                        Synopsis:
                      </Col>
                      <Col sm>
                        <Form.Group controlId="programSynopsis">
                          <Form.Control
                            as="textarea"
                            placeholder="Enter synopsis"
                            value={formData.programSynopsis}
                            onChange={handleFormChange}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mt-4">
                      <Col
                        sm={2}
                        className="align-self-center text-end "
                      >
                        Slot Runtime:
                      </Col>
                      <Col xs={2}>
                        <Form.Select
                          id="programSlotRuntimeHours"
                          value={formData.programSlotRuntimeHours}
                          size="sm"
                          onChange={(e) => {
                            handleFormChange(e);
                          }}
                        >
                          {[...Array(7).keys()].map((hour) => (
                            <option
                              key={hour}
                              value={hour}
                            >
                              {hour} hrs
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                      <Col xs={2}>
                        <Form.Select
                          id="programSlotRuntimeMinutes"
                          value={formData.programSlotRuntimeMinutes}
                          size="sm"
                          onChange={(e) => {
                            handleFormChange(e);
                          }}
                        >
                          {[...Array(60 / 5).keys()].map((index) => (
                            <option
                              key={index}
                              value={index * 5}
                            >
                              {index * 5} mins
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col
                        sm={2}
                        className="align-self-center text-end"
                      >
                        Parental Rating:
                      </Col>
                      <Col sm={4}>
                        <Form.Group controlId="programParentalRating">
                          <Form.Control
                            as="select"
                            value={formData.programParentalRating}
                            onChange={handleFormChange}
                          >
                            <option value="">Select Parental Rating</option>
                            {parentalRatingLoading &&
                              "Loading Parental Ratings..."}
                            {parentalRatingError &&
                              "Error loading Parental Ratings"}
                            {parentalRating &&
                              parentalRating.map((rating) => (
                                <option
                                  key={rating._id}
                                  value={rating._id}
                                >
                                  {rating.rating}
                                </option>
                              ))}
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col
                        sm={2}
                        className="align-self-center text-end"
                      >
                        Genre:
                      </Col>
                      <Col>
                        <Form.Group controlId="programGenre">
                          <Form.Control
                            as="select"
                            value={formData.programGenre}
                            onChange={handleFormChange}
                          >
                            <option value="">Select Genre</option>
                            {genreLoading && "Loading genres..."}
                            {genreError && "Error loading genres"}
                            {genre &&
                              genre.map((genre) => (
                                <option
                                  key={genre._id}
                                  value={genre._id}
                                >
                                  {genre.genre}
                                </option>
                              ))}
                          </Form.Control>
                        </Form.Group>
                      </Col>
                      <Col
                        sm={2}
                        className="align-self-center text-end"
                      >
                        SubGenre:
                      </Col>
                      <Col>
                        {subgenreDataLoading && "Loading Subgenres..."}
                        {subgenreDataError && "Select Genre First"}
                        {formData.programGenre !== "" && (
                          <Form.Group controlId="programSubGenre">
                            <Form.Control
                              as="select"
                              value={formData.programSubGenre}
                              onChange={handleFormChange}
                            >
                              <option value="">Select SubGenre</option>
                              {subgenreData &&
                                subgenreData.map((subgenre) => (
                                  <option
                                    key={subgenre._id}
                                    value={subgenre._id}
                                  >
                                    {subgenre.SubGenre}
                                  </option>
                                ))}
                            </Form.Control>
                          </Form.Group>
                        )}
                      </Col>
                    </Row>
                    <Row className="pt-2 mt-2 border-0 border-top">
                      <Col className="text-center text-bg-success ">File</Col>
                      {/* <Col xs={10}></Col> */}
                    </Row>
                    <Row className="pt-2 mt-2">
                      <Col
                        className="text-end  pt-2"
                        xs={2}
                      >
                        Ident:
                      </Col>
                      <Col>
                        <Form.Group controlId="programPreRollFileIdent">
                          <Form.Control
                            as="select"
                            value={formData.programPreRollFileIdent}
                            onChange={handleFormChange}
                          >
                            <option value="">Select Ident</option>
                            {identsLoading && "Loading idents..."}
                            {identsError && "Error loading idents"}
                            {idents &&
                              idents.map((ident) => (
                                <option
                                  key={ident._id}
                                  value={ident._id}
                                >
                                  {ident.name}
                                </option>
                              ))}
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="pt-2 mt-2">
                      <Col
                        className="text-end  pt-2 "
                        xs={2}
                      >
                        Ident Graphics:
                      </Col>
                      <Col>
                        <Select
                          name="programPreRollFileIdentGraphics"
                          isMulti
                          closeMenuOnSelect={false}
                          options={graphics}
                          value={formData.programPreRollFileIdentGraphics}
                          onChange={handleGraphicsChange}
                        />
                      </Col>
                    </Row>
                    <Row className="pt-2 mt-2">
                      <Col
                        className="  pt-2 text-end "
                        xs={2}
                      >
                        Add Breaks:
                      </Col>
                      <Col xs={4}>
                        <Form.Group controlId="programPreRollFileAddBreak">
                          <Form.Control
                            as="select"
                            value={formData.programPreRollFileAddBreak}
                            onChange={handleFormChange}
                          >
                            <option value="">Select Add Break</option>
                            {addBreakChoices.map((addBreakChoice) => (
                              <option
                                key={addBreakChoice.addId}
                                value={addBreakChoice.addId}
                              >
                                {addBreakChoice.addBreak}
                              </option>
                            ))}
                          </Form.Control>
                        </Form.Group>
                      </Col>
                      <Col
                        sm={2}
                        className="text-end pt-2 "
                      >
                        Media Runtime:
                      </Col>
                      <Col sm={4}>
                        <Form.Group controlId="programPreRollFileMediaRuntime">
                          <Form.Control
                            type="text"
                            placeholder="Enter run time"
                            value={formData.programPreRollFileMediaRuntime}
                            onChange={handleFormChange}
                            maxLength={3}
                          />
                        </Form.Group>
                        <small>0 = default</small>
                      </Col>
                    </Row>
                    <Row className="m-2 m-auto ">
                      <Col
                        sm={2}
                        className="text-end pt-2 "
                      >
                        In Program Breaks:
                      </Col>
                      <Col xs={4}>
                        <Form.Group controlId="programInProgramBreaks">
                          <Form.Control
                            as="select"
                            value={formData.programInProgramBreaks}
                            onChange={handleFormChange}
                          >
                            {[...Array(3).keys()].map((number) => (
                              <option
                                key={number}
                                value={number}
                              >
                                {number === 0 ? "Zero" : number}
                              </option>
                            ))}
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="pt-2 mt-2 border-0 border-top">
                      <Col className="text-center text-bg-danger ">Live</Col>
                      {/* <Col xs={10}></Col> */}
                    </Row>
                    <Row className="pt-2 mt-2">
                      <Col
                        className="text-end  pt-2 "
                        xs={2}
                      >
                        Intro Ident:
                      </Col>
                      <Col>
                        <Form.Group controlId="programPreRollLiveIntroIdent">
                          <Form.Control
                            as="select"
                            value={formData.programPreRollLiveIntroIdent}
                            onChange={handleFormChange}
                          >
                            <option value="">Select Ident</option>
                            {identsLoading && "Loading idents..."}
                            {identsError && "Error loading idents"}
                            {idents &&
                              idents.map((ident) => (
                                <option
                                  key={ident._id}
                                  value={ident._id}
                                >
                                  {ident.name}
                                </option>
                              ))}
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="pt-2 mt-2">
                      <Col
                        className="text-end  pt-2 "
                        xs={2}
                      >
                        Ident:
                      </Col>
                      <Col>
                        <Form.Group controlId="programPreRollLiveIdent">
                          <Form.Control
                            as="select"
                            value={formData.programPreRollLiveIdent}
                            onChange={handleFormChange}
                          >
                            <option value="">Select Ident</option>
                            {identsLoading && "Loading idents..."}
                            {identsError && "Error loading idents"}
                            {idents &&
                              idents.map((ident) => (
                                <option
                                  key={ident._id}
                                  value={ident._id}
                                >
                                  {ident.name}
                                </option>
                              ))}
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="pt-2 mt-2 ">
                      <Col
                        className="text-end  pt-2 "
                        xs={2}
                      >
                        Ident Graphics:
                      </Col>
                      <Col>
                        <Select
                          name="programPreRollLiveIdentGraphics"
                          isMulti
                          closeMenuOnSelect={true}
                          options={graphics}
                          value={formData.programPreRollLiveIdentGraphics}
                          onChange={handleGraphicsChange}
                        />
                      </Col>
                    </Row>
                    <Row className="pt-2 mt-2">
                      <Col
                        className="text-end  pt-2 "
                        xs={2}
                      >
                        Media Graphics:
                      </Col>
                      <Col>
                        <Select
                          name="programPreRollLiveMediaGraphics"
                          isMulti
                          closeMenuOnSelect={true}
                          options={graphics}
                          value={formData.programPreRollLiveMediaGraphics}
                          onChange={handleGraphicsChange}
                        />
                      </Col>
                    </Row>
                    <Row className="pt-2 mt-2">
                      <Col
                        className="  pt-2 text-end "
                        xs={2}
                      >
                        Add Breaks:
                      </Col>
                      <Col xs={4}>
                        <Form.Group controlId="programPreRollLiveAddBreak">
                          <Form.Control
                            as="select"
                            value={formData.programPreRollLiveAddBreak}
                            onChange={handleFormChange}
                          >
                            <option value="">Select Add Break</option>
                            {addBreakChoices.map((addBreakChoice) => (
                              <option
                                key={addBreakChoice.addId}
                                value={addBreakChoice.addId}
                              >
                                {addBreakChoice.addBreak}
                              </option>
                            ))}
                          </Form.Control>
                        </Form.Group>
                      </Col>
                      <Col
                        sm={2}
                        className="text-end pt-2 "
                      >
                        Media Runtime:
                      </Col>
                      <Col sm={4}>
                        <Form.Group controlId="programPreRollLiveMediaRuntime">
                          <Form.Control
                            type="text"
                            placeholder="Enter run time"
                            value={formData.programPreRollLiveMediaRuntime}
                            onChange={handleFormChange}
                            maxLength={3}
                          />
                        </Form.Group>
                        <small>0 = default</small>
                      </Col>
                    </Row>
                    <Row className="mt-3 ">
                      <Col className="text-start mt-3 ">
                        <Button
                          variant="primary"
                          // type="submit"
                          className="mt-3 ms-3"
                          onClick={handleUpdateTemplateClick}
                        >
                          Update Template
                          {isSpinner && (
                            <Spinner
                              className="ms-2 "
                              animation="border"
                              size="sm"
                            />
                          )}
                        </Button>
                      </Col>
                      <Col className="text-end mt-3 ">
                        <>
                          <Button
                            variant="success"
                            className="mt-3 ms-3 "
                            disabled={isFormDirty}
                            onClick={clearForm}
                          >
                            Add Program
                          </Button>
                          <Button
                            variant="danger"
                            type="submit"
                            disabled={!isFormDirty}
                            className="mt-3 ms-3"
                          >
                            Save
                          </Button>
                        </>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form>
            </Col>
          </>
        )}
      </Row>
    </small>
  );
};
export default Programs;

function setFormDataDetails(setFormData, formData, program) {
  setFormData({
    ...formData,
    programName: program.name,
    programSynopsis: program.synopsis,
    programSlotRuntime: program.slotRuntime,
    programSlotRuntimeHours: Math.floor(program.slotRuntime / 60),
    programSlotRuntimeMinutes: program.slotRuntime % 60,
    programParentalRating: program.parentalrating || "",
    programGenre: program.Genre || "",
    programSubGenre: program.Subgenre || "",
    programInProgramBreaks: program.inProgramBreaks || 0,
    programPreRollFileIdent: program?.preRoll?.file?.ident || "",
    programPreRollLiveIdent: program?.preRoll?.live?.ident || "",
    programPreRollLiveIntroIdent: program?.preRoll?.live?.introIdent || "",
    programPreRollFileIdentGraphics: program?.preRoll?.file?.graphics || [],
    programPreRollLiveIdentGraphics: program?.preRoll?.live?.graphics || [],
    programPreRollLiveMediaGraphics: program?.preRoll?.live?.media || [],
    programPreRollFileAddBreak: program?.preRoll?.file?.addBreak || 0,
    programPreRollLiveAddBreak: program?.preRoll?.live?.addBreak || 0,
    programPreRollFileMediaRuntime: program?.preRoll?.file?.mediaRuntime || 0,
    programPreRollLiveMediaRuntime: program?.preRoll?.live?.mediaRuntime || 0,
  });
}
